var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import "./footer.scss";
import translations from "../../translations/resources/en-GB.json";
var Footer = function () {
    var footerTabs = [
        {
            tabTitle: translations.data["venonboard.footer.tabServiceTerms"],
            tabLink: "https://legal.here.com/en-gb/terms",
        },
        {
            tabTitle: translations.data["venonboard.footer.tabPrivacyPolicy"],
            tabLink: "https://legal.here.com/en-gb/privacy",
        },
        {
            tabTitle: translations.data["venonboard.footer.tabCookiePolicy"],
            tabLink: "https://legal.here.com/en-gb/privacy/cookie-policy",
        },
    ];
    var currentYear = new Date().getFullYear();
    return (_jsxs("footer", __assign({ className: "footerContainer" }, { children: [_jsx("div", __assign({ className: "footerTabs" }, { children: footerTabs.map(function (item, index) {
                    return (_jsx("div", __assign({ className: "footerLinks", onClick: function () {
                            window.open(item.tabLink);
                        } }, { children: item.tabTitle }), "".concat(item.tabTitle, "-").concat(index)));
                }) })), _jsxs("div", __assign({ className: "footerYear" }, { children: ["\u00A9 ", currentYear, " ", translations.data["venonboard.footer.companyCopywrite"]] }))] })));
};
export default Footer;
